import React from 'react';
import Tilt from 'react-parallax-tilt';
import styles from './Card.module.scss';
import { motion } from 'framer-motion';

export interface CardProps {
	icon: React.ReactNode;
	title: string;
	description: React.ReactNode;
}

const Card: React.FC<CardProps> = ({ title, description, icon }) => {
	return (
		<Tilt tiltReverse tiltMaxAngleX={5} tiltMaxAngleY={5}>
			<motion.div
				initial={{ opacity: 0, y: 50 }}
				animate={{ opacity: 1, y: 0 }}
				transition={{ delay: 2.6 }}
				className={styles.container}
			>
				<div>
					<div className={styles.icon}>{icon}</div>
					<h4 className={styles.title}>{title}</h4>
				</div>
				<div className={styles.description}>{description}</div>
			</motion.div>
		</Tilt>
	);
};

export default Card;
